import EventEmitter from 'EventEmitter';

const events = {
  ADD_ITINERARY: '@routing/ADD_ITINERARY',
  ADD_TESSA_ITINERARY: '@routing/ADD_TESSA_ITINERARY',
  ITINERARY_CREATED: '@routing/ITINERARY_CREATED',
};
const RoutingEventEmitter = new EventEmitter();

export { events, RoutingEventEmitter };
